import { useNavigate } from "react-router-dom";

import useDoctorNotifications from "../../hooks/useDoctorNotifications";
import { ROUTES } from "../../routes";
import { SITUATION_CLASS_UI } from "../../constants/notificationClasses";
import { getNotificationPreviewLine } from "../../utils/notificationMessage";

import "./doctor-notifications.css";

/**
 * Компактное первичное предупреждение под шапкой — только для новых id (не «свернутых»).
 */
export default function NotificationEntryBanner() {
    const navigate = useNavigate();
    const { enabled, getBannerNotification, dismissBanner } = useDoctorNotifications();

    const alert = enabled ? getBannerNotification() : null;
    if (!alert) return null;

    const accent = SITUATION_CLASS_UI[alert.situation_class]?.accent ?? "warning";
    const isCritical = alert.situation_class === "S4";
    const previewLine = getNotificationPreviewLine(alert);

    return (
        <div
            className={`doctor-notification-entry-banner doctor-notification-entry-banner--${accent} ${isCritical ? "doctor-notification-entry-banner--critical" : ""}`}
            role="status"
            aria-live="polite"
        >
            <div className="doctor-notification-entry-banner__inner">
                <div className="doctor-notification-entry-banner__text">
                    <span className={`doctor-notification-badge doctor-notification-badge--${accent}`}>
                        {alert.situation_class}
                    </span>
                    <strong className="doctor-notification-entry-banner__title">{alert.title}</strong>
                    {previewLine ? (
                        <p className="doctor-notification-entry-banner__message">{previewLine}</p>
                    ) : null}
                </div>
                <div className="doctor-notification-entry-banner__actions">
                    <button
                        type="button"
                        className="doctor-notification-btn doctor-notification-btn--primary"
                        onClick={() => navigate(ROUTES.NOTIFICATIONS, { viewTransition: true })}
                    >
                        Открыть
                    </button>
                    <button
                        type="button"
                        className="doctor-notification-btn doctor-notification-btn--ghost"
                        onClick={() => dismissBanner(alert.id)}
                    >
                        Свернуть
                    </button>
                </div>
            </div>
        </div>
    );
}
